{
	"main": {
		"title": "Štartna lista jadralni",
		"nezakljuceni": "NEZAKLJUČENI LETI",
		"zakljuceni": "ZAKLJUČENI LETI"
	},
	"table": {
		"reg": "REG.",
		"titleJ": "Izpis jadralnih letov",
		"datum": "DATUM",
		"vzlet": "VZLET",
		"pilot": "PILOT",
		"naloga": "NALOGA",
		"pristanek": "PRISTANEK"
	},
	"labels": {
		"datumOd": "Datum OD :",
		"datumDo": "Datum DO :",
		"pilotJ": "Izberi pilota jadralnega letala:",
		"instruktor": "Izberi inštruktorja jadralnega letala:",
		"registracijaJ": "Izberi reg. jadralnega letala :",
		"namenJ": "Izberi namen :",
		"nalogaJ": "Izberi nalogo jadralnega leta:",
		"pilotM": "Izberi pilota vlečnega letala:",
		"registracijaM": "Izberi reg. letala za vleko :",
		"vzlet": "Izberi vzlet :",
		"pristanek": "Izberi pristanek :",
		"poletanje": "Poletanje :",
		"odklop": "Odklop :",
		"nezakljucen": "Nezaključen let?",
		"pristanekJ": "Pristanek jadralnega letala:",
		"pristanekM": "Pristanek vlečnega letala:",
		"opomba": "Opomba"
	},
	"modal": {
		"registracija": "registracija",
		"pilot": "pilot",
		"regVleke": "reg. vleke:",
		"instruktor": "inštruktor: ",
		"namen": "namen:",
		"naloga": "naloga: ",
		"casVzleta": "čas vzleta:",
		"casOdklopa": "čas odklopa:",
		"casPristanka": "čas pristanka:",
		"casLetenja": "čas letenja:",
		"casVleke": "čas vleke:",
		"opomba": "opomba: ",
		"datumL": "datum letenja: ",
		"datumV": "datum vnosa: "
	},
	"edit": {
		"titleJ": "PODATKI JADRALNEGA LETALA",
		"regJ": "registracija jadralnega letala:",
		"pilotJ": "pilot jadralnega letala:",
		"instruktor": "inštruktor:",
		"namenJ": "namen jadralnega letala:",
		"nalogaJ": "naloga jadralnega letala:",
		"titleM": "PODATKI VLEČNEGA LETALA",
		"pilotM": "pilot vlečnega letala:",
		"regM": "registracija vlečnega letala",
		"titleS": "SPLOŠNI PODATKI",
		"krajV": "kraj vzleta:",
		"krajP": "kraj pristanka:",
		"casV": "čas vzleta:",
		"casO": "čas odklopa:",
		"casPJ": "čas pristanka jadralnega letala:",
		"casPM": "čas pristanka vlečenega letala:",
		"opomba": "Opomba:"
	},
	"modalNL": {
		"title": "Zaključi izbran zapis",
		"regJ": "registracija:",
		"pilotJ": "pilot:",
		"regM": "reg. vleke:",
		"instruktor": "inštruktor",
		"namen": "namen: ",
		"naloga": "naloga: ",
		"casV": "čas vzleta:",
		"casO": "čas odklopa:",
		"pristanekJ": "Pristanek jadralnega letala:",
		"casVL": "čas vleke:",
		"opomba": "opomba: ",
		"datumL": "datum letenja: ",
		"datumV": "datum vnosa: "
	},
	"buttons": {
		"zakljuciLet": "Zaključi let",
		"brisiIzbiro": "Pobriši izbiro",
		"urediPodatke": "Uredi podatke",
		"posodobiPodatke": "Posodobi podatke",
		"izbrisiZapis": "Izbriši zapis",
		"csv": "Izvoz v CSV ",
		"natisni": "Natisni ",
		"poslji": "Pošlji "
	},
	"data": {
		"title": "Podatki",
		"stPristankov": "Št. pristankov:",
		"stLetov": "Št. letov:",
		"casVZraku": "Trajanje:"
	},
	"obvestila": {
		"zapisPrihodnost": "Zapis ima izbran datum v prihodnosti, POPRAVI izbran datum!",
		"zapisCasPrihodnost": "Zapis ima pri enem ali več zapisih uro v prihodnosti, preglej čase!",
		"zapisCasNapaka": "Časi zapisov so nepravilni! Preveri čase še enkrat!",
		"napakaPristanka": "Čas pristanka ne more biti pred časom poleta!",
		"zapisPobrisan": "Zapis uspešno pobrisan",
		"napakaPrazenPristanek": "Napaka pri vnosu, čas pristanka ne more biti prazen",
		"posodobitevUspesna": "Posodobitev uspešna",
		"napakaPosodabljanja": "Napaka pri posodabljanju podatkov.",
		"napakaBranja": "Napaka pri branju podatkov.",
		"napakaIzbrisa": "Napaka pri izbrisu podatkov.",
		"vprasanjeIzbris": "Ali res želite pobrisati zapis?",
		"napakaVnosa": "Napaka pri vnosu, preglej če imaš izpolnjena vsa polja!",
		"letZakljucen": "Let uspešno zaključen.",
		"letNiZakljucen": "Napaka pri zaključevanju leta."
	}
}